import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import { NgClass } from '@angular/common';
import { UserTypes } from '../../../shared/types/user.model';
import { KorviuButtonComponent } from '../../../shared/components/korviu-button/korviu-button.component';
import { ReferralModalFacade } from '../services/referral-modal.facade';
import { AuthService } from 'core/services/auth.service';

interface UserTypeListItem {
  userType: UserTypes;
  imageSrc: string;
  title: string;
  description: string;
}

@Component({
  selector: 'app-select-new-referral-user-type-modal',
  standalone: true,
  imports: [TranslateModule, KorviuButtonComponent, NzModalModule, NgClass],
  templateUrl: './select-new-referral-user-type-modal.component.html',
  styleUrl: './select-new-referral-user-type-modal.component.scss'
})
export class SelectNewReferralUserTypeModalComponent {
  public selectedUserType: UserTypes;
  public userTypeList: UserTypeListItem[];

  constructor(
    private _modal: NzModalRef,
    private _referralModalFacade: ReferralModalFacade,
    authService: AuthService
  ) {
    const userTypeListItemsByCurrentUserType: Map<UserTypes, UserTypes[]> = new Map([
      [UserTypes.PR, [UserTypes.PR, UserTypes.SD]]
    ]);
    this.userTypeList = [
      /*{
        userType: UserTypes.AY,
        imageSrc: 'assets/img/dashboard/ganaliados.svg',
        title: 'userTypes.ganaliado',
        description: 'dashboard.recruitAssociate'
      },
      {
        userType: UserTypes.CO,
        imageSrc: 'assets/img/dashboard/ganagente.svg',
        title: 'userTypes.ganagente',
        description: 'dashboard.recruitCoordinatorsToExpandAndMultiplyYourRewards.'
      },
      {
        userType: UserTypes.RE,
        imageSrc: 'assets/img/dashboard/ganaquipo.svg',
        title: 'userTypes.ganaquipo',
        description: 'dashboard.buildYourTeamWithRecruiters'
      },*/
      {
        userType: UserTypes.SD,
        imageSrc: 'assets/img/dashboard/member.svg',
        title: 'userTypes.member',
        description: 'dashboard.inviteGanamigosInTheUSMexico'
      },
      {
        userType: UserTypes.PR,
        imageSrc: 'assets/img/dashboard/ganasocio.svg',
        title: 'userTypes.ganasocio',
        description: 'dashboard.growWithTrustedPartners'
      }
    ].filter((type: UserTypeListItem) => {
      const availableListItems = userTypeListItemsByCurrentUserType.get(authService?.currentUser?.userType);
      return availableListItems.includes(type?.userType);
    });
    this.selectedUserType = this.userTypeList[0]?.userType;
  }

  public onContinueClick(): void {
    this._referralModalFacade.openAddNewReferralFormModal({ userType: this.selectedUserType });
    this._modal.close();
  }

  public onUserTypeClick(userType: UserTypes): void {
    this.selectedUserType = userType;
  }
}
